import * as tools from '../Tools';

export default class MapState {
    protected mapContainer: HTMLElement;

    constructor() {
        this.mapContainer = <HTMLElement>document.getElementById('karte-drag');
        if (!this.mapContainer) {
            return;
        }
        this.MapState();
    }

    private async MapState() {
        const svgNodes = document.querySelectorAll('use[data-id]');
        svgNodes.forEach( svgNode => {
            svgNode.classList.add('d-none');
        });
        const data = await tools.fetchJSON('/Handler/Parameter/Status');
        for (var i = 0; i < data.length; i++) {
            if (data[i].type !== 'G') {
                const station: HTMLElement = document.querySelector(
                    'use[data-id="' + data[i].id + '"][data-type="' + data[i].type + '"]'
                );
                if (data[i].statusPublic === -1) {
                    data[i].statusPublic = data[i].statusHvd;
                }
                station?.classList.add('fill' + data[i].statusPublic);
                station?.classList.remove('d-none');
            }
        }
        if (this.mapContainer?.dataset?.id !== '') {
            const station: HTMLElement = document.querySelector(
                '#karte [data-id="' +
                    $('#karte-drag').attr('data-id') +
                    '"][data-type="' +
                    $('#karte-drag').attr('data-type') +
                    '"]'
            );
            if (station) {
                station?.dispatchEvent(new Event('click'));
                station.style.display = '';
            }
        }
        if (this.mapContainer?.dataset?.start === 'true') {
            // Startseite, nur Pegel und Städte anzeigen
            //
            document.querySelectorAll('#karte use[data-type="T"]').forEach((el: HTMLElement) => {
                el.style.display = 'none';
            });
            document.querySelectorAll('#karte use[data-type="W"]').forEach((el: HTMLElement) => {
                el.style.display = 'none';
            });
        }
        document.getElementById('svgInit').style.display = 'none';
    }
}
